<nb-card nbInfiniteList class="base-page">
  <nb-card-header class="page-title" *ngIf="title">{{ title }}</nb-card-header>
  <nb-card-body>
    <ng-content></ng-content>
  </nb-card-body>
</nb-card>
